function tradeCoinText (url) {
  let res = "";
  return res = ajax_post(url)
}

function ajax_post(url){
  return new Promise(
  function (resolve, reject) {
    var ajax = new XMLHttpRequest();
      ajax.open('get',url);
      ajax.setRequestHeader("Content-type","application/x-www-form-urlencoded");
      ajax.send(new URLSearchParams());
      ajax.onreadystatechange=function(){
        if(ajax.readyState==4&&ajax.status==200){
          resolve(JSON.parse(ajax.responseText))
      }
    }
  })
}
export default tradeCoinText;